<style scoped></style>

<template>
  <div>
    <textarea
      name="introduction"
      class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      cols="40"
      rows="10"
      id="id_introduction"
      :value="this.introduction"
    />
    <p class="mt-1 text-sm text-gray-500 text-right">
      <button @click="showFileDialog">
        {{ $t('editor.add_attachment') }}
      </button>
    </p>

    <p class="mt-2 text-sm text-gray-500">
      {{ $t('editor.introduction_explainer') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'IntroductionEditor',
  data() {
    return {
      introduction: this.initialIntroduction,
    };
  },
  props: {
    csrftoken: String,
    initialIntroduction: String,
  },
  methods: {
    showFileDialog(e) {
      e.preventDefault();

      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;

      input.onchange = async (e) => {
        const files = e.target.files;

        for (let i = 0; i < files.length; i++) {
          const file = await this.uploadFile(files.item(i));
          this.introduction += `\n- [${file.name}](${file.url})`;
        }
      };

      input.click();
    },
    async uploadFile(file) {
      const data = new FormData();
      data.append('file', file, file.name);

      const response = await fetch('/attachments/create', {
        method: 'POST',
        headers: {
          'X-CSRFToken': this.csrftoken,
        },
        body: data,
      });

      if (!response.ok) {
        return;
      }

      const responseData = await response.json();
      return responseData.attachments[0];
    },
  },
};
</script>
